import React from "react";
import Navbar from "./components/Navbar";
import { Switch, Route } from "react-router-dom";
import HomePage from "./components/HomePage";
import AboutPage from "./components/AboutPage";
import ServicePage from "./components/ServicePage";
import ContactPage from "./components/ContactPage";
import SkillPage from "./components/SkillPage";

const Home = () => {
  return (
    <>
      <Navbar />
      <HomePage/>
      
    </>
  );
};

const About = () => {
  return (
    <>
      <Navbar />
      <AboutPage/>
      
    </>
  );
};

const Service = () => {
  return (
    <>
      <Navbar />
     <ServicePage/>
    </>
  );
};
const Skill = () =>{
  return (
    <>
    <Navbar />
    <SkillPage/>
      </>
  )
}

const Contact = () => {
  return (
    <>
      <Navbar />
      <ContactPage/>
    </>
  );
};

const App = () => {
  return (
    <Switch>
      <Route exact path="/">
        <Home />
      </Route>

      <Route path="/about">
        <About />
      </Route>

      <Route path="/service">
        <Service />
      </Route>
      <Route path="/skill">
        <Skill />
      </Route>
      <Route path="/contact">
        <Contact />
      </Route>
      <Route path="#">
        <About/>
      </Route>
    </Switch>
  );
};

export default App;
